export default __webpack_public_path__ + "static/media/uploader-medtronic6xG-1.e2bb6486.png";